import { createFileRoute, redirect } from '@tanstack/react-router';
import { visibleReferenceTypes } from '../../../../features/admin/reference';
import { useCurrentUser } from '../../../../state/use-current-user';

// /admin/reference opens the first tab the role may see.
export const Route = createFileRoute('/_auth/admin/reference/')({
  beforeLoad: () => {
    const role = useCurrentUser.getState().user?.role;
    const [first] = role ? visibleReferenceTypes(role) : [];
    if (!first) throw redirect({ to: '/admin/ideas' });
    throw redirect({ to: '/admin/reference/$type', params: { type: first } });
  },
});
